import { wealthProApi } from '../../redux/api';
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const buildEventsQuery = ({ page, limit, sort, searchTerm }) => {
    let baseQuery = `/api/reports/system/events?page=${page}&limit=${limit}`;
    if (sort && sort.length > 0) {
        baseQuery += `&sort=${sort}`;
    }
    if (searchTerm && searchTerm.length > 0) {
        baseQuery += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return baseQuery;
};

const reportEventEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchReportMicroserviceEvents: builder.query({
            query: (props) => buildEventsQuery(props),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
        publishReportMicroserviceOutboxEvent: builder.mutation({
            query: (eventId) => ({
                url: `/api/reports/system/outbox/events/${eventId}`,
                method: 'POST',
                body: { }
            })
        })
    })
});

export const {
    useFetchReportMicroserviceEventsQuery,
    useLazyFetchReportMicroserviceEventsQuery,
    usePublishReportMicroserviceOutboxEventMutation
} = reportEventEndpoints;